import { useAtom } from 'jotai'
import { aCheckedListings } from '~/atoms'
import type { Listing } from '~/models'
import { Checkbox } from '../ui'

export default function SelectionCheckbox({ listing }: { listing: Listing }) {
  const [checkedListings, setCheckedListings] = useAtom(aCheckedListings)
  const label = listing.name || listing.property.address

  return (
    <Checkbox
      className="absolute left-2 top-2 z-40 hidden h-8 w-8 border-background bg-background text-accent-foreground shadow-md ring-primary ring-offset-transparent hover:outline-none hover:ring-1 hover:ring-offset-1 data-[state=checked]:border-primary sm:block"
      checked={checkedListings.includes(listing.id)}
      aria-label={`Select ${label}`}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        setCheckedListings((prev) => {
          if (prev.includes(listing.id)) {
            return prev.filter((id) => id !== listing.id)
          }
          return [...prev, listing.id]
        })
      }}
    />
  )
}
